<template>
  <div>
    input_config
    <el-input v-model="inputVal" />
    {{ videoData }}
    <div @click="clickFun">
      点击展示 选择视频弹窗
    </div>
  </div>
</template>
<script>
export default {
  name: 'SpSelectDateConfig',
  props: {
    videoData: {
      type: String
    }
  },
  data () {
    return {
      inputVal: null
    }
  },
  watch: {},
  created () {},
  methods: {
    clickFun () {
      this.$emit('getVideo', 'Video')
      this.$emit('showPickerTmp', { publicTmpName: 'PublicTmpVideoSelect' })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/weappTmps/formTmps/index.scss';
</style>
